/* eslint-disable max-len */
import React, { memo, useCallback, useMemo } from 'react'

import {
  FiltersSidebar,
  Icon,
  Button,
  Quality as QualityIcon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { addQuality, removeQuality, clearQualityContent, setContentSource } from 'Pods/SearchPage/Store/actions/qualityContent'
import { QUALITY_LEVEL, CONTENT_SOURCE } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

import { qualityFiltersConfig, contentSourceFiltersConfig } from './constants'
import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'

const prefixIcon = <Icon notSpaced svgComponent={QualityIcon} color="dark" size="small" />

function Quality() {
  const quality = useSearchPageStore(state => state.quality)
  const contentSource = useSearchPageStore(state => state.contentSource)

  const hasSelectedAnyFilter = useMemo(() => {
    return quality[0] !== QUALITY_LEVEL.ANY || contentSource !== CONTENT_SOURCE.ALL
  }, [quality, contentSource])

  const handleReset = useCallback(() => {
    clearQualityContent()
  }, [])

  const handleQualityFilterChange = useCallback((_, value, isOn) => {
    if (isOn) {
      addQuality(value)
    } else {
      removeQuality(value)
    }
  }, [])

  const handleContentSourceFilterChange = useCallback((_, value) => {
    setContentSource(value)
  }, [])

  const selectedContentSource = useMemo(() => [contentSource], [contentSource])

  const content = useMemo(() => (
    <>
      <FiltersSidebar
        isCollapsible={false}
        filters={qualityFiltersConfig}
        selectedFilters={quality}
        onFiltersChange={handleQualityFilterChange}
        isControlled
        useNewCheckboxes
        hideShowMore
        baseFormWrapperClassName="filter-wrapper__content"
      />
      <FiltersSidebar
        isCollapsible={false}
        filters={contentSourceFiltersConfig}
        selectedFilters={selectedContentSource}
        onFiltersChange={handleContentSourceFilterChange}
        hideLastDivider
        hideShowMore
        baseFormWrapperClassName="filter-wrapper__content"
        useRadio
      />
      <Button
        type="ghost"
        size="tiny"
        customClass="filter-wrapper__reset-button"
        onClick={handleReset}
        disabled={!hasSelectedAnyFilter}
      >
        Reset
      </Button>
    </>
  ), [
    quality,
    selectedContentSource,
    handleQualityFilterChange,
    handleContentSourceFilterChange,
    handleReset,
    hasSelectedAnyFilter,
  ])

  return (
    <FiltersWrapper
      placeholder="Quality"
      prefixIcon={prefixIcon}
      content={content}
      hasSelectedAnyFilters={hasSelectedAnyFilter}
      closingDropdownClassName="filter-wrapper"
    />
  )
}

export default memo(Quality)
